import { render, staticRenderFns } from "./BlockPakkettenKoppelen.vue?vue&type=template&id=7425b00e&"
import script from "./BlockPakkettenKoppelen.vue?vue&type=script&lang=js&"
export * from "./BlockPakkettenKoppelen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports